import { render, staticRenderFns } from "./PageLogsIntro.vue?vue&type=template&id=fda168f8&scoped=true&"
import script from "./PageLogsIntro.vue?vue&type=script&lang=js&"
export * from "./PageLogsIntro.vue?vue&type=script&lang=js&"
import style0 from "./PageLogsIntro.vue?vue&type=style&index=0&id=fda168f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda168f8",
  null
  
)

export default component.exports